import React, {useContext, useEffect, useState} from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import PagesRouter from './PagesRoutes';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import Loading from '../components/Ui/loading/Loading';
import GlobalContext from '../context/GlobalContext';
import {getToken} from "../helpers/Token.helper";


const AppRoutes = () => {

    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [mentorias, setMentorias] = useState([]);
    const [mentorProfile, setMentorProfile] = useState({});

    useEffect(() => {
        setToken(getToken()); // localstorage a contexto global
    }, []);

    return (
        <GlobalContext.Provider value={{token, setToken, loading, setLoading, mentorProfile, setMentorProfile, mentorias, setMentorias}}>
            <Router>
                <Header/>
                <div>
                    <Switch>
                        <Route path="/" component={PagesRouter} />
                        <Redirect to="/" />
                    </Switch>
                </div>
                <Footer/>
            </Router>
            {
                (loading)&&
                    <Loading />
            }
        </GlobalContext.Provider>
    )
}

export default AppRoutes;
